export const HTTP_SUCCESS = 200
export const HTTP_UNAUTHORIZED = 401
export const HTTP_FORBIDDEN = 403